import { CardModel } from "./Poker.CardModel";

export class DeckModel {
    
    private deck = new Array<number>(52);
    private currentCard = 0;
    private previousCard = 0;

    constructor(){
        for (let i = 0; i < 52; i++) {
            this.deck[i] = 0;
        }
    }

    public get currentCardId() : number {
        if ((this.currentCard < 0) || (this.currentCard > 51))
            return 0;
        return this.deck[this.currentCard];
    }
    
    dealCard(): number {
        if (this.currentCard < 52) {
            this.previousCard = this.currentCard;
            this.currentCard++;
            let returnValue = this.deck[this.currentCard];
            return returnValue;
        }
        return 0;
    }

    undoCard(): number {
        if (this.previousCard > 0) {
            this.previousCard--;
            this.currentCard--;
            let returnValue = this.deck[this.currentCard];
            return returnValue;
        }
        return 0;
    }

    replayDeck(): void {
        this.currentCard = -1;
        this.previousCard = -1;
    }

    shuffleCards(): void {

        let deck1 = new Array<number>(52);
        for (let i = 0; i < 52; i++) {
            deck1[i] = Math.random();
        }

        for (let iPos = 0; iPos < 52; iPos++) {
            let maxValue = -1;
            let maxIndex = 1;
            for (let indx = 0; indx < 52; indx++) {
                if (maxValue < deck1[indx]) {
                    maxValue = deck1[indx];
                    maxIndex = indx;
                }
            }
            this.deck[iPos] = maxIndex + 1;
            deck1[maxIndex] = -1;
        }

        this.currentCard = -1;
        this.previousCard = -1;
    }
}